export enum SearchModels {
  SaleOrder = 'sale.order',
  Case = 'project.task',
  Partner = 'res.partner',
  Return = 'stock.picking',
  PackageLines = '',
  Package = ' ',
  Product = 'product.product',
  Inbound = 'purchase.order',
  User = 'res.users',
  Country = 'res.country',
  Mappings = 'df.mapping.product',
  Invoices = 'df.merchant.invoice',
  Claim = 'df.claim',
  Carrier = 'df.carrier.company',
  CountryGroup = 'res.country.group',
  Workflow = 'df.workflow',
  Connector = 'df.connector',
}

export const SearchFieldsRegistry: Record<SearchModels, string[]> = {
  [SearchModels.SaleOrder]: [
    'name',
    'partner_id.name',
    'id',
    'partner_id.street',
    'partner_id.city',
    'partner_id.zip',
    'partner_id.country_code',
    'order_line.product_id.name',
    'order_line.product_id.default_code',
    'order_line.product_id.barcode',
  ],
  [SearchModels.Case]: ['topic', 'id', 'assigned_user'],
  [SearchModels.Partner]: ['name', 'company_name', 'email'],
  [SearchModels.Return]: [
    'name',
    'partner_id.name',
    'partner_id.street',
    'partner_id.zip',
    'partner_id.city',
    'country_code',
  ],
  [SearchModels.Product]: ['name', 'barcode', 'default_code'],
  [SearchModels.Inbound]: [
    'id',
    'name',
    'partner_id.name',
    'partner_id.street',
    'partner_id.zip',
    'order_line.product_id.name',
    'order_line.product_id.default_code',
    'order_line.product_id.barcode',
  ],
  [SearchModels.User]: ['name', 'email', 'user_name', 'partner_id.zip', 'partner_id.city'],
  [SearchModels.Country]: ['name', 'continent_name'],
  [SearchModels.Mappings]: ['id', 'barcode', 'sku', 'name'],
  [SearchModels.PackageLines]: [],
  [SearchModels.Package]: [],
  [SearchModels.Invoices]: ['name', 'ref', 'invoice_origin'],
  [SearchModels.Claim]: ['name', 'tracking_number', 'order_number', 'sale_order_id.name'],
  [SearchModels.Carrier]: ['name'],
  [SearchModels.CountryGroup]: ['name'],
  [SearchModels.Workflow]: ['name'],
  [SearchModels.Connector]: ['name'],
};
